import {
  BoldButton,
  ItalicButton,
  UnderlineButton,
  HeadlineTwoButton,
  HeadlineThreeButton,
  UnorderedListButton,
  OrderedListButton,
  SubscriptButton,
} from 'draft-js-buttons';

import { LinkButton, SuperscriptButton } from '../components/ui/ToolbarButtons';

const defaultToolbarButtons = [
  BoldButton,
  ItalicButton,
  UnderlineButton,
  HeadlineTwoButton,
  HeadlineThreeButton,
  LinkButton,
  UnorderedListButton,
  OrderedListButton,
  SubscriptButton,
  SuperscriptButton,
];

export function getToolbarButtons({ disabledButtons = [] } = {}) {
  const toolbarButtons = [...defaultToolbarButtons];

  if (disabledButtons.includes('bold')) {
    toolbarButtons.splice(defaultToolbarButtons.indexOf(BoldButton), 1);
  }

  return toolbarButtons;
}

export default defaultToolbarButtons;
